<template>
	<div class="itembatterie">
		<h2>{{skala.ueberschrift}}</h2>
		<p>{{skala.instruktion}}</p>
		<div class="fragebogentabelle">
			<!-- Beschriftung oben -->
			<ul class="anker">
				<li class="frage">&nbsp;</li>
				<li class="antwort">
					<!-- Nur die extremen Antwortkategorien werden semantisch verankert -->
					<ul v-if="darstellung=='1'" class="kategorien">
						<li v-for="(ankerx, ankerxx) in skala.anker" v-bind:key="ankerxx" class="kategorie" :class="ankerxx==0 ? 'kategorie_links' : 'kategorie_rechts' ">
							<small v-if="ankerxx==0">{{ankerx.auspraegung}}</small>
							<small v-else-if="ankerxx==(skala.anker.length-1)">{{ankerx.auspraegung}}</small>
							<small v-else>&nbsp;</small>
						</li>
					</ul>
					<!-- Jede Antwortkategorie wird semantisch verankert -->
					<ul v-if="darstellung=='2'" class="kategorien">
						<li v-for="(ankerx, ankerxx) in skala.anker" v-bind:key="ankerxx" class="kategorie">
							<small>{{ankerx.auspraegung}}</small>
						</li>
					</ul>
				</li>
			</ul>
			<!-- Dreieck -->
			<ul class="dreieck">
				<li class="frage">&nbsp;</li>
				<li class="antwort"><img src="../assets/dreieck.svg" id="dreieck" style="width:100%;height:1.5em;" alt="dreieck" /></li>
			</ul>
			<!-- Items -->
			<ul v-for="(frage, fragex) in skala.fragen" v-bind:key="fragex" class="item " :class="(skala.fragen[fragex].item % 2) ? 'grau' : '' ">
				<li class="frage">{{skala.fragen[fragex].frage}}</li>
				<li class="antwort">
					<!-- Checkboxes -->
						<!-- Checkbox -->
						<div class="kategorien">
						<v-radio-group row dense >
							<v-radio v-for="(ankerx, ankerxx) in skala.anker" v-bind:key="ankerxx" class="kategorie"
								:id="skala.fragen[fragex].skala+'_'+skala.fragen[fragex].item+'_'+ankerx.wert"
								:name="skala.fragen[fragex].skala+'_'+skala.fragen[fragex].item"
								:value="ankerx.wert"
								@click="antwortItem(skala.fragen[fragex].skala+'_'+skala.fragen[fragex].item, ankerx.wert)"
							></v-radio>
						</v-radio-group>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	export default {
	name: 'Itembatterie',
	props: {
		fragebogen: String,
		darstellung: String
	},
	data: function() {
		return {
			skalen: {},
			skala: {},
			antworten: {}
		}
	},
	mounted() {
		this.skalenHolen();
	},
	computed: {
		teilnehmer() {
			return this.$store.state.teilnehmer;
		}
	},
	methods: {
		skalenHolen: function() {
			axios.get('https://www.arbeitsverdichtung.de/api/skalen', {
				params: {
					e: [this.fragebogen]
				}
			})
			.then(response => {
				this.skalen = response.data;
				this.skala = response.data[0];
			})
			.catch(error => {
				this.errorMessage = error.message;
				console.error("There was an error!", error);
			});
		},
		antwortItem: function(item, antwort) {
			this.antworten[item] = antwort;
			console.log('itembatterie.vue');
			console.log(item + ' / ' + antwort);
			console.log(this.antworten);
			this.$emit('fragebogenAntwort', {item, antwort});
		}
	}
  }
</script>
<style scoped>
	div.fragebogentabelle {
		display: table;
		table-layout: fixed;
		margin-top: 1em;
	}
	ul.anker, ul.dreieck , ul.item {
		display: table-row;
		min-height: 3em;
	}
	ul.item:hover {
		background-color: #ffffcd;
	}
	li.frage {
		width: 100%;
		display: table-cell;
		vertical-align: middle;
		padding: 0.25em;
	}
	.grau {
		background-color: #f5f5f5;
	}
	ul.anker {
		line-height: 1em;
	}
	li.antwort {
		display: table-cell;
		vertical-align: middle;
		padding: 0.25em;
		margin: 0em;
		text-align: center;
		/* border: 1px #ff0000 solid; */
	}
	ul.kategorien {
		display: table;
		margin: 0em;
		padding: 0em;
		width: 100%;
		/* border: 1px #00ff00 solid; */
	}
	li.kategorie {
		width: 4em;
		min-width: 4em;
		display: table-cell;
		vertical-align: middle;
		text-align: center;
		font-size: 0.75em;
		line-height: 1em;
		font-weight: bold;
		padding: 0em;
		margin: 0em;
		/* border: 1px #00ff9d solid;  */
	}
	.v-input radio-group.v-input radio-group.row .v-radio {
		margin-right: 0px !important;
	}
	.kategorien {
		display: table;
		margin: 0em;
		padding: 0em;
		width: 100%;
		/* border: 1px #00ff00 solid; */
	}
	.kategorie {
		width: 4em;
		min-width: 4em;
		display: table-cell;
		vertical-align: middle;
		text-align: center;
		font-size: 0.75em;
		line-height: 1em;
		font-weight: bold;
		padding: 0em !important;
		margin: 0em !important;
		/* background-color: #00fff2; */
		/* border: 1px #0099ff solid !important;  */
	}
	li.kategorie_links {
		text-align: left;
		width: 25%;
		vertical-align: bottom;
		overflow: visible;
		/* border: 1px #ff0000 solid;  */
	}
	li.kategorie_rechts {
		text-align: right;
		width: 25%;
		/* border: 1px #ff00ff solid;  */
	}
	li.kategorie input[type="radio"] {
		width: 1.5em;
		height: 1.5em;
		text-align: center;
	}
	.v-messages {
		display: none;
	}
	.v-input--selection-controls {
		margin-top: 0px !important;
	}
	.v-input--selection-controls__input {
		margin-right: 0px !important;
	}
	li.kategorie label {
		display: none;
		float: left;
		border: 1px #0000ff dashed;
		width: 100%;
		text-align: left;
		margin-right: 0.5em;
	}
</style>
